import {Injectable} from '@angular/core';
import {EndpointsService} from './endpoints.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';


const skipHeaders = new HttpHeaders({'X-Skip-Interceptor': ''});

@Injectable()
export class BackendApiService {


  constructor(private endPointsService: EndpointsService , private httpClient: HttpClient) {

  }

  callToApi(url: any): Observable<any> {
    return this.httpClient.get<any>(
      url
    );
  }

  callToApiWithHeader(url: any): Observable<any> {
    return this.httpClient.get<any>(
      url , {headers: skipHeaders}
    );
  }

  postApi(url: string, request: any) {
    return this.httpClient.post<any>(url, request)
      .toPromise()
      .then(data => {
          return data
        }, error => {
          
          return null;
        }
      );
  }

  fileUploadPost(url: string, request: any) {
    return this.httpClient.post<any>(url, request)
      .toPromise()
      .then(data => {
          return data
        }, error => {
          
          return null;
        }
      );
  }

}
